import { UpdateFileConfig } from "./UpdateFileConfig";

/** Tipo do objeto de SignIn dos usuários */
type TSignIn = { token: string; lastSignInTime: string };
/** Tipo do objeto com as permissões para cada produto do Rubk. */
type TProducts = { faturamento: boolean; orcamento: boolean };

/**
 * Modelo de usuários.
 * @category Users
 * @interface User
 * @hideconstructor
 */
export class User {
  /** Nome do usuário */
  displayName: string;
  /** E-mail do usuário. (Seu LogIn) */
  email: string;
  /** Flag que define se o e-mail atual do usuário foi verificado e é válido/existente. */
  emailVerified: boolean;
  /** Define se o usuário logou como anônimo.
   * @depreciated
   */
  isAnonymous: boolean;
  /** Número de telefone. */
  phoneNumber: string;
  /** URL para download da foto de perfil do usuário. */
  photoURL: string;
  /** ID do usuário no Authentication do Firebase. */
  uid: string;
  /** Data de criação do usuário. */
  creationTime: string;
  /** Data e hora do último logIn do usuário no Rubk. */
  lastSignInTime: string;
  /** Último token de autenticação do usuário. */
  token: string;
  /** Tipo de autenticação do usuário.
   * @default "password"
   */
  providerId: string;
  /** Lista dos projetos favoritos do usuário. */
  favorites: string[];
  /** Flag que indica se o usuário é trial. */
  trial: boolean;
  /** Flag que indica se o período trial do usuário já expirou. */
  trialExpired: boolean;
  /** Flag que define se o pode ser exibido o tutorial para o usuário. */
  showTutorial: boolean;
  /** Espaço total de armazenamento ocupado por todos os modelos 3D upados nos projetos do usuário. */
  totalFileSize: number;
  /** Flag que indica se o usuário vai fazer o primeiro login no sistema. */
  firstLogin: boolean;
  /** Nome da empresa. */
  companyName?: string;
  /** Cargo ocupado pelo usuário. */
  jobTitle?: string;
  /** Flag que define se o usuário é membro do time Rubk para acesso a funcionalidades administradoras do sistema. */
  rubk?: boolean;
  /** Desconhecido. */
  defaultLocation?: string;
  /** Flag que define se o usuário está ativo ou não no sistema. Bloqueando seu login. */
  disabled?: boolean;
  /** Token e data do último logIn do usuário no Rubk Orçamento. */
  lastSignOnOrcamento?: TSignIn;
  /** Objeto com as configurações personalizadas do usuário para importação de uma planilha na EAP. */
  updateFileConfig?: UpdateFileConfig;
  /** Objeto com permissões de acesso do usuário aos produtos Rubk. */
  products?: TProducts;
  /** Propriedade que define o tipo de acesso do usuário na empresa que ele pertence. */

  changeDescription?: boolean;
  access: number = 1;

  gclid?: string;
  utm_campaign?: string;
  utm_keyword?: string;
  utm_medium?: string;
  utm_source?: string;

  constructor(
    displayName: string,
    email: string,
    emailVerified: boolean,
    isAnonymous: boolean,
    phoneNumber: string,
    photoURL: string,
    uid: string,
    creationTime: string,
    lastSignInTime: string,
    token: string,
    providerId: string,
    favorites: string[] = [],
    trial: boolean = false,
    trialExpired: boolean = false,
    showTutorial: boolean = true,
    totalFileSize: number = 0,
    firstLogin: boolean = true,
    companyName: string = "",
    jobTitle: string = "",
    rubk: boolean = false,
    updateFileConfig?: UpdateFileConfig,
    products?: TProducts,
    lastSignOnOrcamento?: TSignIn,
    defaultLocation?: string,
    changeDescription?: boolean,
    disabled: boolean = false,
    gclid: string = "",
    utm_campaign: string = "",
    utm_keyword: string = "",
    utm_medium: string = "",
    utm_source: string = ""
  ) {
    this.displayName = displayName;
    this.email = email;
    this.emailVerified = emailVerified;
    this.isAnonymous = isAnonymous;
    this.phoneNumber = phoneNumber;
    this.photoURL = photoURL;
    this.uid = uid;
    this.creationTime = creationTime;
    this.lastSignInTime = lastSignInTime;
    this.token = token;
    this.providerId = providerId;
    this.favorites = favorites;
    this.trial = trial;
    this.trialExpired = trialExpired;
    this.showTutorial = showTutorial;
    this.totalFileSize = totalFileSize;
    this.firstLogin = firstLogin;
    this.companyName = companyName;
    this.jobTitle = jobTitle;
    this.rubk = rubk;
    this.defaultLocation = defaultLocation;
    this.disabled = disabled;
    this.lastSignOnOrcamento = lastSignOnOrcamento;
    this.updateFileConfig = updateFileConfig;
    this.products = products;
    this.gclid = gclid;
    this.utm_campaign = utm_campaign;
    this.utm_keyword = utm_keyword;
    this.utm_medium = utm_medium;
    this.utm_source = utm_source;
    this.changeDescription = changeDescription;
  }
}

export function createUserModel(data): User {
  if (!data) throw new Error("Invalid user data!");
  return new User(
    data.displayName,
    data.email,
    data.emailVerified,
    data.isAnonymous,
    data.phoneNumber,
    data.photoURL,
    data.uid,
    data.creationTime,
    data.lastSignInTime,
    data.token,
    data.providerId,
    data.favorites,
    data.trial,
    data.trialExpired,
    data.showTutorial,
    data.totalFileSize,
    data.firstLogin,
    data.companyName,
    data.jobTitle,
    data.rubk,
    data.updateFileConfig,
    data.products || { orcamento: true, faturamento: false },
    data.lastSignOnOrcamento,
    data.defaultLocation,
    data.disabled,
    data.gclid,
    data.utm_campaign,
    data.utm_keyword,
    data.utm_medium,
    data.utm_source,
    data.changeDescription
  );
}

export function createBlankUser(): User {
  return new User("", "", false, true, "", "", "", "", "", "", "");
}



// WEBPACK FOOTER //
// ./src/modules/login/models/User.ts